import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "stageRef",
  class: "stage"
}
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-copy" }
const _hoisted_5 = { class: "lead" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "season-badge" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "recolor-copy" }
const _hoisted_11 = { class: "kicker-chip" }
const _hoisted_12 = { class: "recolor-pair" }
const _hoisted_13 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_home_audience = _resolveComponent("home-audience")!
  const _component_home_looks = _resolveComponent("home-looks")!
  const _component_home_season_preview = _resolveComponent("home-season-preview")!
  const _component_home_frames_carousel = _resolveComponent("home-frames-carousel")!
  const _component_home_palettes_grid = _resolveComponent("home-palettes-grid")!
  const _component_home_studio_tools = _resolveComponent("home-studio-tools")!
  const _component_home_features = _resolveComponent("home-features")!
  const _component_home_stock_looks = _resolveComponent("home-stock-looks")!
  const _component_home_footer = _resolveComponent("home-footer")!
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "blobs",
      "aria-hidden": "true",
      style: _normalizeStyle(_ctx.blobStyle)
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "blob b1" }, null, -1),
      _createElementVNode("span", { class: "blob b2" }, null, -1),
      _createElementVNode("span", { class: "blob b3" }, null, -1)
    ]))], 4),
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "grain",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "kicker-chip" }, "Rainbow Manager", -1)),
          _createElementVNode("h1", null, _toDisplayString(_ctx.t('welcomeText')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('welcomeSubText')), 1),
          _createVNode(_component_router_link, {
            class: "cta",
            to: "/signUp"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('getStarted')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "hero-collage",
          "aria-label": _ctx.t('homeLooksTitle')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collage, (card, index) => {
            return (_openBlock(), _createElementBlock("figure", {
              key: card.src,
              class: _normalizeClass('c' + index)
            }, [
              _createElementVNode("img", {
                src: card.src,
                alt: _ctx.t(card.titleKey)
              }, null, 8, _hoisted_7)
            ], 2))
          }), 128)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('softAutumnPaletteShort')), 1)
        ], 8, _hoisted_6)
      ]),
      _createVNode(_component_home_audience),
      _createVNode(_component_home_looks),
      _createVNode(_component_home_season_preview),
      _createVNode(_component_home_frames_carousel),
      _createVNode(_component_home_palettes_grid),
      _createVNode(_component_home_studio_tools),
      _withDirectives((_openBlock(), _createElementBlock("section", {
        class: "recolor",
        "aria-label": _ctx.t('homeAiRecolorTitle')
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('aiAgent')), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeAiRecolorTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('homeAiRecolorText')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('homeFeatureAiText')), 1),
          _createVNode(_component_router_link, {
            class: "cta",
            to: "/signUp"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('getStarted')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recolor, (shot) => {
            return (_openBlock(), _createElementBlock("figure", {
              key: shot.src,
              class: _normalizeClass({ tall: shot.tall })
            }, [
              _createElementVNode("img", {
                src: shot.src,
                alt: _ctx.t(shot.captionKey)
              }, null, 8, _hoisted_13),
              _createElementVNode("figcaption", null, _toDisplayString(_ctx.t(shot.captionKey)), 1)
            ], 2))
          }), 128))
        ])
      ], 8, _hoisted_9)), [
        [_directive_home_reveal]
      ]),
      _createVNode(_component_home_features),
      _createVNode(_component_home_stock_looks),
      _createVNode(_component_home_footer)
    ])
  ], 512))
}